export const ru = {
    horizontal: 'Горизонтальный',
    square: 'Квадратный',
    vertical: 'Вертикальный'
};
